import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard'; 
import UnpaidReport from './pages/UnpaidReports';
import InvoicePrint from './pages/InvoicePrint';
import PrivateRoute from './auth/PrivateRoute';
import PaymentTransact from './pages/PaymentTransact';
import Jemaat from './pages/Jemaat';
import MemberBetania from './pages/MemberBetania';
import NewMember from './pages/NewMember';
import BillingGenerator from './pages/BillingGenerator';
import ReportsPage from './pages/Reports';
import PaymentHistory from './pages/PaymentHistory';

import AppLayout from "./components/AppLayout";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route element={<PrivateRoute />}>
          <Route element={<AppLayout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/memberbetania" element={<MemberBetania />} />
            <Route path="/newmember" element={<NewMember />} />
            <Route path="/jemaat" element={<Jemaat />} />
            <Route path="/billinggenerator" element={<BillingGenerator />} />
            <Route path="/payments" element={<PaymentTransact />} />
            <Route path="/paymenttransact" element={<PaymentTransact />} />
            <Route path="/paymenthistory" element={<PaymentHistory />} />
            <Route path="/unpaid" element={<UnpaidReport />} />
            <Route path="/reports/:jenisReport" element={<ReportsPage />} />
            <Route path="/invoice/:id" element={<InvoicePrint />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
 
